export default function AtlasFramework() {
  return (
    <section id="framework" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#0F172A] mb-4">
            The Atlas Implementation Model
          </h2>
          <p className="text-xl text-gray-600">
            Four Phases. Zero Chaos.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-search-line text-3xl text-[#0F172A]"></i>
            </div>
            <div className="text-sm font-bold text-gray-500 mb-2">Step 1</div>
            <h3 className="text-xl font-bold text-[#0F172A] mb-3">
              Diagnostic Mapping
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              We audit your workflows, revenue channels, and friction points.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-draft-line text-3xl text-[#0F172A]"></i>
            </div>
            <div className="text-sm font-bold text-gray-500 mb-2">Step 2</div>
            <h3 className="text-xl font-bold text-[#0F172A] mb-3">
              Structural Design
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              We engineer AI systems aligned to real business metrics.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-rocket-line text-3xl text-[#0F172A]"></i>
            </div>
            <div className="text-sm font-bold text-gray-500 mb-2">Step 3</div>
            <h3 className="text-xl font-bold text-[#0F172A] mb-3">
              Controlled Deployment
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Systems are deployed with minimal disruption.
            </p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center border-2 border-[#0F172A]">
              <i className="ri-line-chart-line text-3xl text-[#0F172A]"></i>
            </div>
            <div className="text-sm font-bold text-gray-500 mb-2">Step 4</div>
            <h3 className="text-xl font-bold text-[#0F172A] mb-3">
              Performance Optimization
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              We refine based on live operational data.
            </p>
          </div>
        </div>

        <div className="relative w-full h-[400px] mb-8">
          <img
            src="https://public.readdy.ai/ai/img_res/c0b86c0c258075e3b6e1a500876d3a9e.jpg"
            alt="Implementation Process Flow"
            className="w-full h-full object-cover object-center"
          />
        </div>

        <p className="text-center text-lg text-gray-700 font-medium">
          Intelligence should strengthen your business — not complicate it.
        </p>
      </div>
    </section>
  );
}